angular.module("Main").controller("AutoSurveysController", ["$state", "$stateParams",
    function ($state, $stateParams) {
        var vm = this;

        let clubId = $stateParams.cid;
        let mandantId = $stateParams.club;
        if (_.isUndefined($stateParams.id)) {
            var uuid = false;
        } else if ($stateParams.id) {
            var uuid = $stateParams.id;
        }
        if (!_.isEmpty(clubId) && _.isEmpty(mandantId)) {
            $state.go("onlinesales", {cid: clubId, id: uuid});
        } else if (!_.isEmpty(clubId) && !_.isEmpty(mandantId)) {
            $state.go("onlinesalesClub", {cid: clubId, club: mandantId, id: uuid});
        }
        else
            $state.go("no_access_online_sales");

    }]);